import ajax from "../../authenticationSafeAjax";
import uuid from "uuid";
import { stringify } from "query-string";
import moment from "moment";
import momentTz from "moment-timezone";
import { isNil, not, filter, compose } from "ramda";

export function fetchCommunications(criteria, callback) {
    const isCustomPeriod = criteria.period.periodStart && criteria.period.periodEnd;
    const parameters = filter(compose(not, isNil), {
        communicatorId: criteria.communicator,
        periodStart: isCustomPeriod ? criteria.period.periodStart : null,
        periodEnd: isCustomPeriod ? criteria.period.periodEnd : null,
        periodTz: isCustomPeriod ? moment.tz.guess() : null
    });

    const request = {
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        url: `/disclosure/api/communications?${stringify(parameters)}`
    };

    ajax(request, (statusCode, responseBody) => {
        const communications = JSON.parse(responseBody);
        callback(communications.map(communication => Object.assign({id: uuid.v4()}, communication)));
    });
}

export function fetchCommunicators(onResponse) {
    ajax({ url: "/disclosure/api/communicators" }, (statusCode, responseBody) => {
        onResponse(JSON.parse(responseBody));
    });
}



/** WEBPACK FOOTER **
 ** ./src/main/javascript/compliance/monitor/monitorFetchers.js
 **/